import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { hasPermission } from "../RoleBasedComponents";
import "./TopNavbar.css";

const TopNavbar = ({ items, title, actions }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userPermissions = [] } = useAuth();

  // Filter items based on user permissions
  const allowedItems = (items||[]).filter((item) =>
    hasPermission(userPermissions, item.permission)
  );

  // Determine active item based on current URL
  const activeItem =
  allowedItems.find((item) => location.pathname === item.activePath)?.activePath || 
  allowedItems.find((item) => location.pathname.startsWith(item.activePath))?.activePath || 
  allowedItems[0]?.activePath;

  const handleClick = (path) => {
    navigate(path);
  };

  return (
    <div className="top-navbar">
      <div className="top-navbar-header">
        <h1>{title}</h1>
      </div>
      <ul className="top-navbar-menu">
        {(allowedItems || []).map((item, index) => (
          <li
            key={index}
            className={`top-navbar-item ${activeItem === item.path ? "active" : ""}`}
            onClick={() => handleClick(item.path)}
          >
            {item.label}
          </li>
        ))}
      </ul>
      {actions && <div className="top-navbar-actions">{actions}</div>}
    </div>
  );
};

export default TopNavbar;
